export const POLLING_INTERVAL_IN_MS = 1000 as const;
